export const PLATFORM_ANALYTICS_APP_IDS = [
  'data-sources',
  'data-workspace',
  'dashboard-builder',
  'report-builder',
  'analytics-library'
] as const;

export function isPlatformAnalyticsAppId(id: string): boolean {
  return PLATFORM_ANALYTICS_APP_IDS.some((appId) => appId.toLowerCase() === id.toLowerCase());
}
